import "./info-general.modal.scss";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
const InfoGeneralModal = ({ isOpen, onClose, message, message2, icon }) => {

    const handleClose = () => {
        onClose(false);
    }


    return (
        <Modal centered show={isOpen} onHide={onClose} className="info-general-control">
            <Modal.Body className="info-general-body">
                <FontAwesomeIcon icon={faClose} className="info-general-icon-close" onClick={handleClose}></FontAwesomeIcon>

                <img src={icon} className="info-general-icon-trash"></img>

                <p className="info-general-title">
                    {message}
                </p>

                <p className="info-general-description">
                   {message2}
                </p>

                
            </Modal.Body>
        </Modal>
    )
}

export default InfoGeneralModal;